module.exports = __webpack_public_path__ + "static/mobile-74ea908ba17615424b736c2ab4eb3e7f.png";